import { useSelector } from 'react-redux';
import { MaybeHelpDeskInboxIntercept } from 'ui-addon-conversations-settings/help-desk-onboarding/components/MaybeHelpDeskInboxIntercept';
import { getIsUngatedForHelpDesk } from '../../selectors/gateSelectors';
import { hasHelpDeskAccess as hasHelpDeskAccessSelector } from '../../selectors/userSelectors/hasHelpDeskAccess';
import { jsx as _jsx } from "react/jsx-runtime";
export const TryHelpDeskBanner = () => {
  const isUngatedToHelpdesk = useSelector(getIsUngatedForHelpDesk);
  const hasHelpDeskAccess = useSelector(hasHelpDeskAccessSelector);
  return isUngatedToHelpdesk && hasHelpDeskAccess ? /*#__PURE__*/_jsx(MaybeHelpDeskInboxIntercept, {}) : null;
};
TryHelpDeskBanner.displayName = 'TryHelpDeskBanner';